<!-- PROYECTO: Comercial -->
<template>
  <div class="home">
    <div class="section-top">
      <b-container>
        <b-row class="banner-section">
          <b-col class="logo-wrapper" md="12">
            <img src="../assets/comercial1/icn_logo.svg" alt="">
          </b-col>
          <b-col md="6" lg="7" sm="12">
            <h1 class="mt-5 mb-5">Resultados satisfactorios de ahorro de <span class="highlight">energía en tu negocio.</span> </h1>
          </b-col>
          <b-col md="6" lg="5" sm="8" style="position: relative;">
            <div id="contacto" class="form-wrapper">
              <h4 class="text-center">Solicita más información</h4>
              <p class="text-center mb-4">Envíanos un mensaje y uno de nuestros asesores te contactará.</p>

              <!-- Progreso -->
              <div class="steps-progress mb-4">
                <span class="steps-label">Paso {{ currentStep + 1 }} de {{ steps.length }}</span>
                <div class="steps-bar">
                  <div class="steps-bar-fill" :style="{ width: progress + '%' }"></div>
                </div>
              </div>

              <p class="error" v-if="messageSend">{{ messageSend }}</p>

              <!-- PASO 1: Datos de contacto (B2B) -->
              <div v-if="currentKey === 'contacto'">
                <p class="question">Datos de contacto</p>

                <b-form-input class="mb-2" v-model="form.firstname" placeholder="Nombre*" type="text" autocomplete="given-name" :class="{ 'error-input': errors.firstname }"></b-form-input>
                <small class="field-error" v-if="errors.firstname">{{ errors.firstname }}</small>

                <b-form-input class="mb-2" v-model="form.lastname" placeholder="Apellido*" type="text" autocomplete="family-name" :class="{ 'error-input': errors.lastname }"></b-form-input>
                <small class="field-error" v-if="errors.lastname">{{ errors.lastname }}</small>

                <select class="form-control mb-2" v-model="form.rol" :class="{ 'error-input': errors.rol, 'is-empty': !form.rol }">
                  <option value="" disabled>Puesto*</option>
                  <option v-for="opt in rolOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <small class="field-error" v-if="errors.rol">{{ errors.rol }}</small>

                <b-form-input class="mb-2" v-model="form.empresa" placeholder="Nombre de empresa*" type="text" autocomplete="organization" :class="{ 'error-input': errors.empresa }"></b-form-input>
                <small class="field-error" v-if="errors.empresa">{{ errors.empresa }}</small>

                <b-form-input class="mb-2" v-model="form.nombreComercial" placeholder="Nombre comercial" type="text"></b-form-input>

                <b-form-input class="mb-2" v-model="form.phone" placeholder="Celular o WhatsApp*" type="tel" inputmode="tel" autocomplete="tel" :class="{ 'error-input': errors.phone }"></b-form-input>
                <small class="field-error" v-if="errors.phone">{{ errors.phone }}</small>

                <b-form-input class="mb-2" v-model="form.email" placeholder="Correo electrónico*" type="email" autocomplete="email" :class="{ 'error-input': errors.email }"></b-form-input>
                <small class="field-error" v-if="errors.email">{{ errors.email }}</small>
              </div>

              <!-- PASO 2: Ubicación y tipo de solución -->
              <div v-if="currentKey === 'proyecto'">
                <p class="question">¿En dónde se encuentra ubicado tu proyecto?*</p>
                <select class="form-control mb-2" v-model="form.ubicacion" :class="{ 'error-input': errors.ubicacion, 'is-empty': !form.ubicacion }">
                  <option value="" disabled>Selecciona una ubicación*</option>
                  <option v-for="opt in ubicacionOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <small class="field-error" v-if="errors.ubicacion">{{ errors.ubicacion }}</small>

                <template v-if="form.ubicacion === 'Otro'">
                  <b-form-input class="mb-2" v-model="form.ubicacionOtro" placeholder="Especifica la ciudad*" type="text" :class="{ 'error-input': errors.ubicacionOtro }"></b-form-input>
                  <small class="field-error" v-if="errors.ubicacionOtro">{{ errors.ubicacionOtro }}</small>
                </template>

                <p class="question mt-4">¿Qué tipo de solución necesitas?*</p>
                <div class="option-list">
                  <label
                    v-for="opt in solucionOptions"
                    :key="opt"
                    class="option"
                    :class="{ selected: form.soluciones.includes(opt) }">
                    <input type="checkbox" :value="opt" v-model="form.soluciones">
                    <span>{{ opt }}</span>
                  </label>
                </div>
                <small class="field-error" v-if="errors.soluciones">{{ errors.soluciones }}</small>
              </div>

              <!-- PASO 3 (condicional): Etapa constructiva -->
              <div v-if="currentKey === 'etapa'">
                <p class="question">Etapa constructiva*</p>
                <div class="option-list">
                  <div v-for="opt in etapaOptions" :key="opt.label">
                    <label class="option" :class="{ selected: form.etapa === opt.label }">
                      <input type="radio" name="etapa" :value="opt.label" v-model="form.etapa">
                      <span>{{ opt.label }}</span>
                    </label>
                    <div v-if="opt.sub && form.etapa === opt.label" class="sub-options">
                      <span class="sub-title" v-if="opt.subTitle">{{ opt.subTitle }}*</span>
                      <label
                        v-for="sub in opt.sub"
                        :key="sub.label"
                        class="option option-sm"
                        :class="{ selected: form.etapaDetalle === sub.label }">
                        <input type="radio" name="etapaDetalle" :value="sub.label" v-model="form.etapaDetalle">
                        <span>
                          {{ sub.label }}
                          <span class="option-hint" v-if="sub.hint">{{ sub.hint }}</span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <small class="field-error" v-if="errors.etapa">{{ errors.etapa }}</small>
              </div>

              <!-- ÚLTIMO PASO: Alcance de solución + Recibo CFE -->
              <div v-if="currentKey === 'alcance'">
                <p class="question">Alcance de solución*</p>
                <div class="option-list">
                  <div v-for="opt in alcanceOptions" :key="opt.label">
                    <label class="option" :class="{ selected: form.alcance === opt.label }">
                      <input type="radio" name="alcance" :value="opt.label" v-model="form.alcance">
                      <span>{{ opt.label }}</span>
                    </label>
                    <div v-if="opt.sub && form.alcance === opt.label" class="sub-options">
                      <span class="sub-title" v-if="opt.subTitle">{{ opt.subTitle }}*</span>
                      <label
                        v-for="sub in opt.sub"
                        :key="sub.label"
                        class="option option-sm"
                        :class="{ selected: form.alcanceDetalle === sub.label }">
                        <input type="radio" name="alcanceDetalle" :value="sub.label" v-model="form.alcanceDetalle">
                        <span>{{ sub.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <small class="field-error" v-if="errors.alcance">{{ errors.alcance }}</small>

                <p class="question mt-4">Recibo de CFE <span class="optional">(opcional)</span></p>
                <div class="file-upload" :class="{ 'error-input': errors.reciboCfe }">
                  <input
                    ref="reciboInput"
                    id="recibo-cfe"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                    @change="onFileChange">
                  <label for="recibo-cfe" v-if="!form.reciboCfe">
                    Adjuntar archivo
                    <span class="option-hint">PDF, JPG o PNG · máx. {{ maxFileMb }} MB</span>
                  </label>
                  <div class="file-selected" v-else>
                    <span class="file-name">{{ form.reciboCfe.name }}</span>
                    <button type="button" class="file-remove" @click="removeFile">Quitar</button>
                  </div>
                </div>
                <small class="field-error" v-if="errors.reciboCfe">{{ errors.reciboCfe }}</small>
              </div>

              <!-- Honeypot anti-spam -->
              <b-form-input autocomplete="off" tabindex="-1" class="pet-field" v-model="form.pet" placeholder="Alimento de mascota" type="text"></b-form-input>

              <!-- Navegación -->
              <div class="form-nav">
                <b-button v-if="currentStep > 0" class="btn btn-back" :disabled="sending" v-on:click="prevStep">Atrás</b-button>
                <b-button v-if="!isLastStep" class="btn" v-on:click="nextStep">Siguiente</b-button>
                <b-button v-else class="btn" :disabled="sending" v-on:click="sendMessage">{{ sending ? 'Enviando…' : 'Enviar mensaje' }}</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="img-intro"></div>
      <b-container class="pt-5 mt-5">
        <b-row class="features-section">
          <b-col md="12" class="mb-4">
              <h3>Cuando se trata de <span class="highlight"> ahorro <br> inteligente</span>,  Newen te ofrece:</h3>
          </b-col>
          <b-col md="6" lg="3" class="display-flex mb-4 mt-3" style="flex-direction: column;">
              <img src="../assets/comercial1/icn1.svg" alt="">
              <p>Asesoría personalizada para seleccionar el sistema solar que se adapte mejor a tus necesidades. </p>
          </b-col>
          <b-col md="6" lg="3" class="display-flex mb-4 mt-3"  style="flex-direction: column;">
              <img src="../assets/comercial1/icn2.svg" alt="">
              <p>Equipo calificado y capacitado para instalaciones eléctricas, fotovoltaicas y trabajos en alturas.</p>
          </b-col>
          <b-col md="6" lg="3" class="display-flex mb-4 mt-3"  style="flex-direction: column;">
              <img src="../assets/comercial1/icn3.svg" alt="">
              <p>Servicio de postventa; plan de mantenimiento profesional para obtener el mayor rendimiento de energía.</p>
          </b-col>
          <b-col md="6" lg="3" class="display-flex mb-4 mt-3"  style="flex-direction: column;">
              <img src="../assets/comercial1/icn4.svg" alt="">
              <p>Soporte técnico; contamos con un equipo de ingenieros eléctricos y renovables que podrán aclarar todas tus dudas</p>
          </b-col>
        </b-row>
      </b-container>  
      <div class="img-ahorro">
        <b-container>
          <b-row   class="align-items-center" style="height: 70vh;">
            <b-col>
              <b-row >
              <b-col lg="8" md="8">
                <h1>Expertos que <br> <span class="highlight"> transf<img id="o" src="../assets/comercial1/o.png">rman </span></h1>
                <p class="mt-4">Contrata hoy y vive un ahorro de <br>
hasta un 90% en tu costo de energía. </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pt-5 mt-3">
                <img id="linea" src="../assets/comercial1/img_linegradient.png">
              </b-col>
            </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container>
        <b-row class="pt-5">
          <b-col md="12">
            <h5>NEWEN</h5>
            <hr class="hr">
            <b-row class="align-items-start pt-5">
              <b-col md="6">
                <h6>Contribuimos al ahorro de energía de tu negocio. Obteniendo un porcentaje del suministro eléctrico común y el otro de la energía generada por los paneles solares.</h6>
              </b-col>
              <b-col md="6" class="mt-4 " >
                 <img style="width: 100%; height: auto; object-fit: contain;" src="../assets/comercial1/img_comercial3.png"   >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row class="pt-5">
          <b-col md="12">
            <hr class="hr">
            <b-row class="align-items-center pt-5 justify-content-center">
              <b-col md="5" lg="6">
              </b-col>
              <b-col md="6" lg="5"> 
                <img  class="hide" src="../assets/comercial1/icon.svg">
              </b-col>
            </b-row>
            <b-row class="align-items-start pt-3 justify-content-center">
              <b-col md="5" lg="6">
                <img style="width: 100%; height: auto; object-fit: contain;" src="../assets/comercial1/img_comercial4.png" alt="">
              </b-col>
              <b-col md="6" lg="5" class="margin" > 
                <img  class="show" src="../assets/comercial1/icon.svg">
                <h6>Instalamos sistemas solares interconectados a la red. Un sistema que combina lo mejor de los dos mundos, <span class="grey">ayudándote a pagar mucho menos de luz y a generar tu propia energía de manera limpia y económica.</span> </h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
 
 
    </div>
    <div class="section-bottom pt-5 mt-5">
      <b-container class=" pt-5">

      <b-row class="footer-wrapper align-items-center justify-content-between">
        <b-col lg="8" sm="12">
          <h3>¡Comienza a integrar <br> <span class="highlight">  soluciones    de ahorro!</span></h3>
          <p class="mt-3">Envíanos un mensaje para más información, uno de <br> nuestros asesores estará en contacto contigo a la brevedad.</p>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <a href="#contacto" class="btn btn-footer">Comenzar ahora <img src="../assets/comercial/icn_send.svg" alt=""></a>
        </b-col>
      </b-row>

  
      <b-row class="justify-content-start">
        <b-col md="3" sm="3" class="fifty">
          <img id="logoabajo" src="../assets/comercial1/icn_logo.svg" alt="">
        </b-col>
        <b-col md="7" sm="7" class="footer-img fifty">
          <img id="linea2" src="../assets/comercial1/img_linegradient.png">
        </b-col>
      </b-row>
    </b-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// Ruta de create-lead.php en el servidor de esta landing (ajústala si está en otra carpeta)
const API_URL = '/create-lead.php'
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const MAX_FILE_MB = 5
const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png']

// Tracking de campañas (UTM + identificadores de clic de Meta y Google)
const TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'fbclid', 'gclid']
const TRACKING_STORAGE_KEY = 'newen_tracking'
const TRACKING_TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 días

// Google Ads – conversión "Website lead"
const GADS_LEAD_CONVERSION = 'AW-11274654803/GfiiCMCA78UYENOoloAq'

// Esta landing es solo comercial: se omite la pregunta de aplicación
const APLICACION = 'Comercial'

// Puesto (B2B)
const PUESTOS = ['Propietario', 'Director', 'Gerente', 'Encargado de área', 'Otro']

// Ubicación
const UBICACIONES = ['Mexicali', 'Tecate', 'Tijuana', 'Rosarito', 'Ensenada', 'San Quintín', 'San Felipe', 'Otro']

// Tipo de solución (B2B)
const SSFV = 'Sistema Solar Fotovoltaico (Paneles solares)'
const SOLUCIONES = [
  SSFV,
  'Sistema de Almacenamiento de Energía con Baterías (BESS)',
  'Calidad de Energía (Código de Red)',
  'Electromovilidad (Cargadores Eléctricos)',
  'Consultoría (Asesoría, Trámites y Gestoría)'
]

// Etapa constructiva (solo si eligió SSFV)
const OBRA = [
  { label: 'Obra Negra', hint: 'Trabajos preliminares, cimentación, estructura primaria y muros gruesos' },
  { label: 'Obra Gris', hint: 'Muros levantados, techos cerrados e instalaciones base (eléctricas, hidráulicas, sanitarias)' },
  { label: 'Obra Blanca', hint: 'Aplanados de yeso, pintura, pisos, azulejos y colocación de luminarias, apagadores y accesorios' }
]
const TIEMPO = [
  { label: 'Menos de 1 año' },
  { label: 'Más de 1 año' },
  { label: 'En remodelación y/o ampliación' }
]
const ETAPAS = [
  { label: 'En proceso de diseño' },
  { label: 'En proceso de construcción', subTitle: 'Etapa de la obra', sub: OBRA },
  { label: 'Tiempo en operación', subTitle: 'Tiempo en operación', sub: TIEMPO }
]

// Alcance de solución
const ALCANCES = [
  { label: 'Proyecto Llave en Mano (SSFV)' },
  {
    label: 'Operación y Mantenimiento',
    subTitle: 'Tiempo de vida del sistema',
    sub: [
      { label: 'Menos de 1 año' },
      { label: '1 a 2 años' },
      { label: '2 a 5 años' },
      { label: '5 a 10 años' },
      { label: 'Más de 10 años' }
    ]
  },
  { label: 'Trámites y Gestoría' },
  {
    label: 'Otro',
    subTitle: '¿Qué servicio necesitas?',
    sub: [
      { label: 'Consultoría' },
      { label: 'Ingeniería y Diseño' },
      { label: 'Mano de Obra' },
      { label: 'Comisionamiento' }
    ]
  }
]

export default {
  name: 'Home',
  mounted() {
    this.tracking = this.captureTracking()
  },
  data() {
    return {
      currentStep: 0,
      sending: false,
      messageSend: '',
      errors: {},
      tracking: {},
      maxFileMb: MAX_FILE_MB,
      rolOptions: PUESTOS,
      ubicacionOptions: UBICACIONES,
      solucionOptions: SOLUCIONES,
      etapaOptions: ETAPAS,
      alcanceOptions: ALCANCES,
      form: {
        firstname: '',
        lastname: '',
        rol: '',
        empresa: '',
        nombreComercial: '',
        phone: '',
        email: '',
        ubicacion: '',
        ubicacionOtro: '',
        soluciones: [],
        etapa: '',
        etapaDetalle: '',
        alcance: '',
        alcanceDetalle: '',
        reciboCfe: null,
        pet: ''
      }
    }
  },
  computed: {
    showEtapa() {
      return this.form.soluciones.includes(SSFV)
    },
    selectedEtapa() {
      return ETAPAS.find(o => o.label === this.form.etapa) || null
    },
    selectedAlcance() {
      return ALCANCES.find(o => o.label === this.form.alcance) || null
    },
    steps() {
      const steps = ['contacto', 'proyecto']
      if (this.showEtapa) steps.push('etapa')
      steps.push('alcance')
      return steps
    },
    currentKey() {
      return this.steps[this.currentStep]
    },
    isLastStep() {
      return this.currentStep === this.steps.length - 1
    },
    progress() {
      return ((this.currentStep + 1) / this.steps.length) * 100
    }
  },
  watch: {
    'form.ubicacion'(valor) {
      if (valor !== 'Otro') this.form.ubicacionOtro = ''
    },
    'form.etapa'() {
      this.form.etapaDetalle = ''
    },
    'form.alcance'() {
      this.form.alcanceDetalle = ''
    },
    showEtapa(visible) {
      if (!visible) {
        this.form.etapa = ''
        this.form.etapaDetalle = ''
      }
    }
  },
  methods: {
    /**
     * Lee los UTM de la URL. Si vienen, se guardan 30 días en localStorage
     * (último clic de campaña). Si no vienen, se usan los guardados de una visita anterior.
     */
    captureTracking() {
      const pageInfo = {
        landing_url: window.location.href.slice(0, 500),
        referrer: (document.referrer || '').slice(0, 500)
      }

      const params = new URLSearchParams(window.location.search)
      // Si el router usa modo hash, los parámetros pueden venir después del #
      const hashQuery = window.location.hash.split('?')[1]
      if (hashQuery) {
        new URLSearchParams(hashQuery).forEach((value, key) => {
          if (!params.has(key)) params.set(key, value)
        })
      }

      const current = {}
      TRACKING_KEYS.forEach(key => {
        const value = params.get(key)
        if (value) current[key] = value.trim().slice(0, 500)
      })

      if (Object.keys(current).length) {
        const data = Object.assign({}, current, pageInfo, { expires: Date.now() + TRACKING_TTL_MS })
        try {
          localStorage.setItem(TRACKING_STORAGE_KEY, JSON.stringify(data))
        } catch (e) { /* almacenamiento no disponible: se usa solo en esta visita */ }
        return data
      }

      try {
        const stored = JSON.parse(localStorage.getItem(TRACKING_STORAGE_KEY) || 'null')
        if (stored && stored.expires > Date.now()) return stored
        localStorage.removeItem(TRACKING_STORAGE_KEY)
      } catch (e) { /* almacenamiento no disponible o dato corrupto */ }

      return pageInfo
    },
    /** ID único por envío: Google Ads lo usa para no contar dos veces el mismo lead. */
    generateLeadId() {
      const rand = (window.crypto && window.crypto.getRandomValues)
        ? Array.from(window.crypto.getRandomValues(new Uint32Array(2)), n => n.toString(36)).join('')
        : Math.random().toString(36).slice(2)
      return 'lead-' + Date.now().toString(36) + '-' + rand
    },
    /** Teléfono en formato E.164 para conversiones mejoradas (MX por defecto). */
    phoneE164(phone) {
      const digits = String(phone || '').replace(/\D/g, '')
      if (digits.length === 10) return '+52' + digits
      if (digits.length >= 11 && digits.length <= 13) return '+' + digits
      return ''
    },
    /**
     * Envía la conversión de Google Ads y el evento generate_lead de GA4.
     * Llama a `done` cuando Google confirma el envío o, como máximo, a los 1.5 s,
     * para que la redirección a la página de gracias nunca se quede esperando.
     */
    /**
     * Meta Pixel: evento Lead. eventID = lead_id, para deduplicar si más adelante
     * se envía el mismo lead también por la API de Conversiones de Meta.
     */
    trackMetaLead(leadId) {
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', {
            content_name: 'Formulario landing',
            content_category: APLICACION
          }, { eventID: leadId })
        }
      } catch (e) { /* el Pixel nunca debe impedir la redirección */ }
    },
    trackLeadConversion(leadId, done) {
      let finished = false
      const finish = () => {
        if (finished) return
        finished = true
        done()
      }

      if (typeof window.gtag !== 'function') {
        finish()
        return
      }

      try {
        // Conversiones mejoradas: Google cifra (hash) estos datos antes de enviarlos.
        // Solo se aprovechan si están activadas en la acción de conversión de Google Ads.
        const userData = { email: this.form.email.trim().toLowerCase() }
        const phone = this.phoneE164(this.form.phone)
        if (phone) userData.phone_number = phone
        window.gtag('set', 'user_data', userData)

        window.gtag('event', 'conversion', {
          send_to: GADS_LEAD_CONVERSION,
          transaction_id: leadId,
          event_callback: finish
        })

        window.gtag('event', 'generate_lead', {
          lead_source: 'formulario_landing',
          aplicacion: APLICACION,
          tipo_cliente: 'B2B'
        })
      } catch (e) {
        finish()
        return
      }

      setTimeout(finish, 1500)
    },
    trackingPayload() {
      const t = this.tracking || {}
      const out = {}
      TRACKING_KEYS.concat(['landing_url', 'referrer']).forEach(key => {
        out[key] = typeof t[key] === 'string' ? t[key] : ''
      })
      return out
    },
    validateStep(key) {
      const f = this.form
      const e = {}

      if (key === 'contacto') {
        if (!f.firstname.trim()) e.firstname = 'Ingresa tu nombre.'
        if (!f.lastname.trim()) e.lastname = 'Ingresa tu apellido.'
        if (!f.rol) e.rol = 'Selecciona tu puesto.'
        if (!f.empresa.trim()) e.empresa = 'Ingresa el nombre de la empresa.'
        const digits = f.phone.replace(/\D/g, '')
        if (digits.length < 10 || digits.length > 13) e.phone = 'Ingresa un número a 10 dígitos.'
        if (!EMAIL_RE.test(f.email.trim())) e.email = 'Ingresa un correo válido.'
      }

      if (key === 'proyecto') {
        if (!f.ubicacion) e.ubicacion = 'Selecciona la ubicación del proyecto.'
        if (f.ubicacion === 'Otro' && !f.ubicacionOtro.trim()) e.ubicacionOtro = 'Especifica la ubicación.'
        if (f.soluciones.length === 0) e.soluciones = 'Selecciona al menos una solución.'
      }

      if (key === 'etapa') {
        if (!f.etapa) {
          e.etapa = 'Selecciona la etapa constructiva.'
        } else if (this.selectedEtapa && this.selectedEtapa.sub && !f.etapaDetalle) {
          e.etapa = 'Selecciona una opción de "' + this.selectedEtapa.subTitle + '".'
        }
      }

      if (key === 'alcance') {
        if (!f.alcance) {
          e.alcance = 'Selecciona el alcance de la solución.'
        } else if (this.selectedAlcance && this.selectedAlcance.sub && !f.alcanceDetalle) {
          e.alcance = 'Selecciona una opción de "' + this.selectedAlcance.subTitle + '".'
        }
        if (this.errors.reciboCfe) e.reciboCfe = this.errors.reciboCfe
      }

      this.errors = e
      return Object.keys(e).length === 0
    },
    nextStep() {
      this.messageSend = ''
      if (this.validateStep(this.currentKey)) {
        this.currentStep++
      }
    },
    prevStep() {
      this.messageSend = ''
      this.errors = {}
      if (this.currentStep > 0) this.currentStep--
    },
    onFileChange(event) {
      const file = event.target.files && event.target.files[0]
      const errors = Object.assign({}, this.errors)
      delete errors.reciboCfe

      if (!file) {
        this.form.reciboCfe = null
      } else if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        errors.reciboCfe = 'El archivo debe ser PDF, JPG o PNG.'
        this.removeFile()
      } else if (file.size > MAX_FILE_MB * 1024 * 1024) {
        errors.reciboCfe = 'El archivo no debe pesar más de ' + MAX_FILE_MB + ' MB.'
        this.removeFile()
      } else {
        this.form.reciboCfe = file
      }
      this.errors = errors
    },
    removeFile() {
      this.form.reciboCfe = null
      if (this.$refs.reciboInput) this.$refs.reciboInput.value = ''
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result).split(',')[1])
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    ubicacionFinal() {
      return this.form.ubicacion === 'Otro'
        ? 'Otro: ' + this.form.ubicacionOtro.trim()
        : this.form.ubicacion
    },
    buildSummary() {
      const f = this.form
      const lines = [
        'Aplicación: ' + APLICACION,
        'Puesto: ' + f.rol,
        'Empresa: ' + f.empresa.trim()
      ]
      if (f.nombreComercial.trim()) lines.push('Nombre comercial: ' + f.nombreComercial.trim())
      lines.push('Ubicación: ' + this.ubicacionFinal())
      lines.push('Soluciones: ' + f.soluciones.join(', '))
      if (this.showEtapa) {
        lines.push('Etapa constructiva: ' + f.etapa + (f.etapaDetalle ? ' - ' + f.etapaDetalle : ''))
      }
      lines.push('Alcance: ' + f.alcance + (f.alcanceDetalle ? ' - ' + f.alcanceDetalle : ''))
      lines.push('Recibo de CFE: ' + (f.reciboCfe ? 'adjunto (' + f.reciboCfe.name + ')' : 'no adjuntado'))
      const t = this.tracking || {}
      if (t.utm_source || t.utm_medium || t.utm_campaign) {
        lines.push('Origen: ' + [t.utm_source, t.utm_medium, t.utm_campaign].filter(Boolean).join(' / '))
      }
      return lines.join('\n')
    },
    sendMessage: async function() {
      if (this.sending) return

      // Honeypot: si un bot llenó el campo oculto, no se envía nada
      if (this.form.pet !== '') return

      // Revalida todos los pasos visibles y regresa al primero con errores
      for (let i = 0; i < this.steps.length; i++) {
        if (!this.validateStep(this.steps[i])) {
          this.currentStep = i
          return
        }
      }

      const f = this.form
      this.sending = true
      this.messageSend = ''

      try {
        const leadId = this.generateLeadId()
        const payload = {
          lead_id: leadId,
          first_name: f.firstname.trim(),
          last_name: f.lastname.trim(),
          email: f.email.trim(),
          phone: f.phone.trim(),
          company: f.empresa.trim(),
          message: this.buildSummary(),
          tipo_cliente: 'B2B',
          aplicacion: APLICACION,
          rol_puesto: f.rol,
          nombre_comercial: f.nombreComercial.trim(),
          ubicacion: this.ubicacionFinal(),
          soluciones: f.soluciones,
          etapa_constructiva: this.showEtapa ? f.etapa : '',
          etapa_detalle: this.showEtapa ? f.etapaDetalle : '',
          alcance: f.alcance,
          alcance_detalle: f.alcanceDetalle
        }

        // UTM, fbclid/gclid, URL de llegada y referrer
        Object.assign(payload, this.trackingPayload())

        if (f.reciboCfe) {
          payload.recibo_cfe = {
            name: f.reciboCfe.name,
            type: f.reciboCfe.type,
            size: f.reciboCfe.size,
            data: await this.fileToBase64(f.reciboCfe)
          }
        }

        const response = await axios.post(API_URL, payload)
        const responseData = response && response.data

        if (responseData && (responseData.success === true || responseData.success === 'true')) {
          // Las conversiones solo se cuentan cuando el servidor confirmó el registro
          this.trackMetaLead(leadId)
          await new Promise(resolve => this.trackLeadConversion(leadId, resolve))
          this.$router.push({ name: 'Thanks' })
        } else {
          this.messageSend = 'Error al enviar mensaje, intenta más tarde.'
        }
      } catch (error) {
        /* eslint-disable no-console */
        console.log(error);
        /* eslint-enable no-console */
        this.messageSend = 'Error al enviar mensaje, intenta más tarde.'
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  padding-left: 4%;
  padding-right: 4%; 
}
h1{
  font-weight: 400;
  line-height: 60px;
  font-size: 60px;
}

.img-ahorro h1{
  font-size: 80px;
  line-height: 75px;
  font-weight: 100;
}
h3{
  font-weight: 400;
  font-size: 45px;
  line-height: 45px;
}
p{
  font-size: 20px;
}

.features-section img{
  width: 32%;
  margin-bottom: 20px;
}
.orange{
  color:#F37820;
}
.img-full{
  width: 100%;
}
.display-flex{
  display: flex;
}

#linea{
  height: 6px;
  width: 35vw;
  margin-left:-11vw;
}
.img-ahorro .container{
  padding-left: 3%  ;
}
.banner-section{
  margin-bottom: 115px;
}
.logo-wrapper{
  margin-top: 55px;
  margin-bottom: 55px;
}
.form-wrapper{
    background: #FFF;
    position: absolute;
    padding: 45px 56px;
    border-radius: 20px;
    width: 100% !important;
    max-width: 450px;
    top: 0;
    left: 10%;
    z-index: 4;
}

.hr{
  border: 1px solid #FFFFFF;
}
.error{
  font-weight: 500;
  font-size: 14px !important;
  color: red;
}
.error-input{
  border-color: red !important;
}

h5{
  font-weight: 400;
  font-size:20px;
  line-height: 26px;
  letter-spacing: 18px;
}

.form-wrapper p{
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  color: #091317;
}
.form-wrapper h4{
  font-size: 30px;
  line-height: 39px;
  margin-bottom: 0;
  color: #091317;
  font-weight: 600 !important;
}
.features-section{
  margin-bottom: 115px;
}
.card-feature{
  background: #696868;
  padding: 50px 30px 60px 30px;
  border-radius: 10px;
  height: 100%;
}
.card-feature img{
  height: 52px;
  margin-bottom: 30px;
}
.card-feature p{
  font-size: 18px;
}

.section-bottom{
  background-color: #091317;
  padding-bottom: 50px;
}

.section-bottom h3{
  font-size: 55px;
  line-height: 60px;
  font-weight: 400;
}

.section-bottom p{
  font-size:20px;
  line-height: 30px;
  font-weight: 400;
}
.mid-banner-section .inner-row{
  max-width: 800px;
  margin: auto;
}

#linea2{
 
  width: 68vw;
  
  height: 6px;
  transform: rotate(180deg);
}
 
h6{
  font-weight: 400;
  font-size:41px;
  line-height: 40px;
 
}
.highlight{
  font-weight: 600;
}
.percent-wrapper{
  margin-bottom: 115px;
}
.percent-wrapper .content-text{
  max-width: 460px;
}
.percent-wrapper .content-image{
  padding-right: 4%;
}

.instalation-wrapper{
  background: #696868;
  border-radius: 40px;
  padding: 105px 90px;
  margin-bottom: 155px;
}

 .show{
  display: none;
 }

.img-intro {
    background-image: url("../assets/comercial1/img_comercial1.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 80vh;  
    width: 100%; 
    z-index: 2;  
    margin-top: -5%
}
.img-ahorro {
    background-image: url("../assets/comercial1/img_comercial2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
    height: 70vh;  
    background-color: #003A44;
    z-index: 2;  
    margin-top: -3%
}

.grey{
  color: #FFFDFC80;
}

.line{
  padding-top: 60vh;
}
 
.instalation-wrapper .inc-red{
  margin-bottom: 32px;
} 
.instalation-wrapper p{
  max-width: 850px;
  margin: auto;
  margin-bottom: 45px;
}
.footer-wrapper{
  padding-bottom: 70px;
}
.btn-footer{
  color: #fff;
  background: #F37821;
  font-size: 27px;
  padding: 25px 40px;
  width: 100%;
  margin-right: auto;
  max-width: 500px;
  border-radius: 20px;
}
.btn-footer:hover,
.btn-footer:focus,
.btn-footer:active{
  color: #fff !important;
  background: #F37821 !important;
}

/* FORM INPUTS */
.form-floating > .form-control{
    background: transparent;
    border: #091317 solid 1px;
    color: #091317;
    font-size: 18px;
    outline: none !important;
    border-radius: 10px;
}
/* .form-floating > .form-control, .form-floating > .form-control-plaintext, .form-floating > .form-select {
    height: calc(4rem + 2px);
} */

.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown), .form-floating > .form-control-plaintext:focus, .form-floating > .form-control-plaintext:not(:placeholder-shown){
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    -webkit-transform: scale(0.55) translateY(-2.8rem) translateX(0rem);
    transform: scale(0.55) translateY(-2.8rem) translateX(0rem);
}

label{
    color: #091317;
    font-size: 18px;
}

input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 18px;
    color: #091317 !important;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #091317 !important;
}
.form-wrapper .btn{
    background: #F37820 !important;
    color: #fff;
    border-color: #F37820 !important;
    width: 100%;
    font-weight: 600;
    font-size: 18px;
    height: 58px;
    line-height: 21.94px;
    border-radius: 10px;
}

.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}

/* FORMULARIO POR PASOS */
.steps-label{
  display: block;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #F37820;
  margin-bottom: 6px;
}
.steps-bar{
  height: 4px;
  background: #EEEEEE;
  border-radius: 4px;
  overflow: hidden;
}
.steps-bar-fill{
  height: 100%;
  background: #F37820;
  transition: width .3s ease;
}
.form-wrapper .question{
  font-weight: 600;
  margin-bottom: 12px;
}
.optional{
  font-weight: 400;
  font-size: 14px;
  color: #6C757D;
}
.option-list{
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.option{
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 10px 14px;
  border: 1px solid #CED4DA;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.3;
  cursor: pointer;
  transition: border-color .2s ease, background-color .2s ease;
}
.option:hover{
  border-color: #F37820;
}
.option.selected{
  border-color: #F37820;
  background: #FFF4EC;
}
.option input{
  flex-shrink: 0;
  margin-top: 3px;
  accent-color: #F37820;
}
.option-sm{
  padding: 8px 12px;
  font-size: 15px;
}
.option-hint{
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: #6C757D;
}
.sub-options{
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 8px 0 4px 16px;
  padding-left: 12px;
  border-left: 2px solid #F37820;
}
.sub-title{
  font-size: 14px;
  font-weight: 600;
  color: #091317;
}
.field-error{
  display: block;
  margin: -2px 0 8px;
  font-size: 13px;
  color: red;
}
.form-wrapper select.form-control{
  cursor: pointer;
}
.form-wrapper select.is-empty{
  color: #6C757D;
}
.file-upload{
  border: 1px dashed #CED4DA;
  border-radius: 10px;
  transition: border-color .2s ease;
}
.file-upload:hover{
  border-color: #F37820;
}
.file-upload input[type="file"]{
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}
.file-upload label{
  display: block;
  margin: 0;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}
.file-selected{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
}
.file-name{
  font-size: 15px;
  color: #091317;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-remove{
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: #F37820;
  cursor: pointer;
}
.form-nav{
  display: flex;
  gap: 10px;
  margin-top: 24px;
}
.form-nav .btn{
  flex: 1;
}
.form-wrapper .btn.btn-back{
  background: #FFF !important;
  color: #F37820 !important;
}


@media (max-width: 1350px) { 
  .img-ahorro{   
    background-position: bottom 0px right -170px;
    
  }
}

@media (max-width: 1203px) {
  #linea2{
 margin-left: 11vw;
 width: 56vw;
 
}
  
}
@media (max-width: 995px) { 
  .container{
    padding-left: 0;
    padding-right: 0;
  }

  .img-intro {
    background-size:contain;
    background-position: center;
    height: 60vh;  
  }

  .img-ahorro{
    background-size:cover;
    background-position: bottom 0px right -170px;
    height: 50vh;  
  }
  .img-ahorro .container {
    padding-left: 0% ;
}

.img-ahorro .align-items-center{
  height: 50vh !important;
}

.img-ahorro h1{
 
    font-weight: 400;
    line-height: 60px;
    font-size: 60px;
 
}

.img-ahorro .mt-3{
  margin-top: 0px !important;
}

#o{
  width: 40px;
}
}

@media (max-width: 858px) { 
  .banner-section     .col-md-6 {
 
        width: 95%;
    }
    .img-intro {
    
    padding-bottom: 82vh;
  }


}
@media (max-width: 768px) { 
  .container{
    padding-left: 30px;
    padding-right: 30px; 
  }

 
  h1, .img-ahorro h1, .footer-wrapper h3{
    font-size: 40px;
    line-height: 1.1;
  }
  h3{
    font-size: 30px;
  }
  p{
    font-size: 18px;
  }
  .banner-section{
    margin-bottom: 115px;
 
  }
  .logo-wrapper{
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .logo-wrapper img{
    width: 200px;
  }
  .form-wrapper{
 
    width: 100% !important;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 45px 30px;
  }
  .form-floating label{
    font-size: 16px;
  }
  .features-section{
    margin-bottom: 50px;
  }

  .margin{
  margin-top: 1.5rem !important;
}
  .card-feature{
    background: #696868;
    padding: 50px 30px 60px 30px;
    border-radius: 10px;
    height: 100%;
  }
  .card-feature img{
    margin-bottom: 30px;
  }
  .card-feature p{
    font-size: 18px;
  }

  .mid-banner-section{
    padding: 50px 20px;
    width: calc(100% - 3px);
    margin: auto;
    margin-bottom: 70px;
  }
  .col1{
      flex: 12 0 100%;
      margin-bottom: 10px;
      text-align: center;
  }
  .col2{
      flex: 12 0 100%;
      text-align: center;
  }

  .hide{
    display: none;
  }
 
  #linea{
  width: 55vw;
 
}
  .show {
    display: flex;
  }
  .section-bottom .container{
    padding-left: 0;
    padding-right: 0;
  }
  .img-ahorro{
    background-size:cover;
    background-position: bottom 0px right -380px;
    height: 50vh;  
  }
  .percent-wrapper{
    margin-bottom: 70px;
  }
  .percent-wrapper .content-text{
    max-width: 460px;
  }
  .percent-wrapper .content-image{
    padding-right: 4%;
  }
  #order1{
    order: 2;
  }
  #order2{
    order: 1;
  }
  .img-intro {
    
    padding-bottom: 80vh;
  }
  #linea2{
 margin-left: 24vw;
 width: 40vw;
 
}
  .features-section img{
    width: 80px;
  }
  .instalation-wrapper{
    width: calc(100% - 3px);
    margin: auto;
    padding: 50px 20px 70px 20px;
    margin-bottom: 50px;
  }
  .instalation-wrapper .inc-red{
    margin-bottom: 32px;
  } 

 
  .instalation-wrapper p{
    max-width: 850px;
    margin: auto;
    margin-bottom: 45px;
  }
  .footer-wrapper{
    padding-bottom: 100px;
  }
  .btn-footer{
    font-size: 24px;
    padding: 22px;
    margin-top: 20px;
  }
}

@media(max-width: 581px){
  .section-bottom .container, .img-ahorro .container{
    padding-left: 30px;
    padding-right: 30px; 
  }
  .fifty {
        width: 50% !important;
    }

    #logoabajo {
        width: 160px;
    }

    .banner-section {
        padding-bottom: 82vh;
    }
    #linea2{
 margin-left: 10vw;
 width: 34vw;
 
}
    .img-intro  {
        background-size: cover;
        padding-bottom: 0;
        margin-top: -36vh;
    }
}
</style>
